import React from 'react'
import cs from "../assets/CS.png";
const Coming = () => {
  return (
 <div className="flex flex-col items-center justify-center h-screen bg-black px-4">
<img
  src={cs}
  alt="Coming Soon"
  className="mb-6 w-24 h-auto rounded"
  
/>
</div>
  )
}

export default Coming